import { Marker } from "react-map-gl/mapbox-legacy";
import { confirmValidCoordinates } from "common/utils/coordinates";
import styles from "./__styles__/Marker.module.scss";

export default ({
  latitude,
  longitude,
}: {
  latitude: number;
  longitude: number;
}) => {
  if (!confirmValidCoordinates({ latitude, longitude })) {
    return null;
  }

  return (
    <Marker latitude={latitude} longitude={longitude} offset={[0, -8]}>
      <span className={styles.marker} />
    </Marker>
  );
};
